import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getCurrentUserId,
  getForm,
  getInvalidFields,
  getRoles,
  getShowInviteUserModal,
  getUserModalState,
  getValidationMessage,
} from 'selectors/admin/team/contractor-team';
import {
  loadRolesRequest,
  setShowInviteUserModal,
  updateFormValue,
  submitFormRequest,
  deleteUserRequest,
} from 'actions/admin/team/contractor-team';
import { CONTRACTOR_ROLES } from 'services/utils/users-util';
import InviteUserModal, {
  UserModalState,
} from 'components/shared/modal/InviteUserModal';
import { formatPhoneNumber } from 'services/utils/text-util';

class ContractorTeamUserModalContainer extends Component {
  componentDidMount() {
    if (this.props.roles.length === 0) {
      this.props.dispatch(loadRolesRequest());
    }
  }

  handleClose = () => {
    this.props.dispatch(setShowInviteUserModal(false));
  };

  handleSubmit = () => {
    const role = this.props.roles.find(
      (role) => role.id === this.props.form.rolesId
    );
    this.props.form.title = role ? CONTRACTOR_ROLES[role.name] : '';
    this.props.dispatch(
      submitFormRequest(this.props.form, this.props.currentUserId)
    );
  };

  handleAttributeChange = (attribute, value) => {
    this.props.dispatch(updateFormValue(attribute, value));
  };

  handleEdit = () => {
    this.props.dispatch(setShowInviteUserModal(true, UserModalState.EDIT));
  };

  handleDeleteConfirmation = (result) => {
    if (result) {
      this.props.dispatch(deleteUserRequest(this.props.currentUserId));
    }
  };

  render() {
    const userFormFields = [
      {
        attribute: 'firstName',
        label: 'First Name',
        renderer: 'input',
      },
      {
        attribute: 'lastName',
        label: 'Last Name',
        renderer: 'input',
      },
      {
        attribute: 'email',
        label: 'Email',
        renderer: 'input',
      },
      {
        attribute: 'phoneNumber',
        formatter: formatPhoneNumber,
        label: 'Phone Number',
        renderer: 'input',
      },
      {
        attribute: 'rolesId',
        label: 'Title',
        renderer: 'dropdown',
        options: this.props.roles.map((role) => {
          return { value: role.id, label: CONTRACTOR_ROLES[role.name] };
        }),
      },
    ];

    return (
      <div>
        <InviteUserModal
          form={userFormFields}
          invalidFields={this.props.invalidFields}
          modalState={this.props.userModalState}
          show={this.props.showInviteUserModal}
          values={this.props.form}
          validationMessage={this.props.validationMessage}
          onAttributeChange={this.handleAttributeChange}
          onClose={this.handleClose}
          onDeleteConfirmation={this.handleDeleteConfirmation}
          onEdit={this.handleEdit}
          onSubmit={this.handleSubmit}
        />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentUserId: getCurrentUserId(state),
    form: getForm(state),
    invalidFields: getInvalidFields(state),
    roles: getRoles(state),
    showInviteUserModal: getShowInviteUserModal(state),
    userModalState: getUserModalState(state),
    validationMessage: getValidationMessage(state),
  };
})(ContractorTeamUserModalContainer);



// WEBPACK FOOTER //
// ./src/components/admin/team/ContractorTeamUserModalContainer.js